import { Comedian, ComedianWithSpecialsAndSocialMedia } from "@/data/comedians";
import FeedCarousel, { SlideData } from "./FeedCarousel";

import { SpecialCard } from "../cards/SpecialCard";
import { SpecialWithUnlocked } from "@/data/specials";

interface Props {
  trendingSpecials: SpecialWithUnlocked[];
  comedians: {
    [comedianId: string]: Comedian;
  };
}

export default function TrendingSpecialsFeed({
  trendingSpecials,
  comedians,
}: Props) {
  if (!trendingSpecials || trendingSpecials.length === 0) return null;

  const slides = trendingSpecials
    .map((special) => {
      // Use the comedians dictionary
      const comedian = comedians[special.comedian_id];
      if (!comedian) return null;

      return {
        id: special.id,
        Component: (
          <div className="min-w-0 flex-grow-0 flex-shrink-0 basis-[260px] md:basis-[460px]">
            <SpecialCard
              location="feedTrendingSpecials"
              special={special}
              comedian={comedian}
              height={260}
              width={460}
              mobileWidth={260}
              mobileHeight={146}
              useSquareImgOnMobile={false}
            />
          </div>
        ),
      };
    })
    .filter(Boolean);

  if (slides.length === 0) return null;

  return (
    <FeedCarousel
      title="Trending Specials"
      slides={slides as SlideData[]}
      location="feed"
    />
  );
}
